import { date } from "zod";
import api from "./api.service";
import midiaService from "./midia.service";

export interface ChangePasswordData {
  currentPassword: string;
  newPassword: string;
}

export interface TwoFactorData {
  password: string;
  token?: string;
}

export interface EmployeeData {
  userEmail: string;
  userName: string;
  userSurname: string;
  userSocialName?: string;
  userPassword: string;
  userPhoneNumber: string;
  userGroup: string;
}

class userClass {
  async changePassword(data: ChangePasswordData) {
    const response = await api.put("/change-password", data);
    return response.data;
  }

  async enableTwoFactor(data: TwoFactorData) {
    const response = await api.post("/enable-2fa", data);
    return response.data;
  }

  async verifyTwoFactor(data: TwoFactorData) {
    const response = await api.post("/verify-2fa", data);
    return response.data;
  }

  async disableTwoFactor(data: TwoFactorData) {
    const response = await api.post("/disable-2fa", data);
    return response.data;
  }

  async updateUser(data: any) {
    const response = await api.patch(`/user/${data.userUuid}`, data);
    return response.data;
  }

  async updateProfilePicture(
    imageFile: File,
    user: any,
  ): Promise<{ token: string }> {
    let imageUrl: string;

    imageUrl = await midiaService.enviar(imageFile, "perfil");

    // Envia a URL para o backend
    const response = await api.patch(`/user/${user.userUuid}`, {
      ...user,
      userLogoUrl: imageUrl,
    });

    return response.data;
  }

  async updateUserGroup(data: { userGroup: string }) {
    const response = await api.put("/change-user-group", data);
    return response.data;
  }

  async getEmployees(page: number = 1, limit: number = 10) {
    const response = await api.get(`/employees?page=${page}&limit=${limit}`);
    return response.data;
  }

  async createEmployee(data: EmployeeData) {
    const response = await api.post("/employees", data);
    return response.data;
  }

  async updateEmployee(userUuid: string, data: Partial<EmployeeData>) {
    const response = await api.put(`/employees/${userUuid}`, data);
    return response.data;
  }
}

export const userService = new userClass();
